<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">Edit Profile</h3>
		</div>
	</div>
	<div class="kt-portlet__body">

		<div class="row mt-2 ">
			<div class="col">Role: {{parseRole()}}</div>
			<div class="col"></div>
			<div class="col"></div>
		</div>

		<div class="row mt-3" *ngIf="isSuperAdmin">
			<div class="col">
				<mat-slide-toggle
					[checked]="demoModeService.isDemoMode()"
					(change)="demoModeService.setDemoMode($event.checked)">
					Demo mode (anonymize names)
				</mat-slide-toggle>
				<p class="text-muted small mt-1 mb-0">Replace distributor, market, client, campus, and machine names with generic labels for demos.</p>
				<p class="text-warning small mt-1 mb-0"><strong>Experimental.</strong> Anonymization only applies to text displayed in the app, not URLs. Some data may not be fully anonymized.</p>
			</div>
		</div>

		<div class="row mt-4" *ngIf="canToggleRetailAdminDemo">
			<div class="col">
				<mat-slide-toggle
					[checked]="voucherDemoMode.isEnabled()"
					(change)="onRetailAdminDemoChange($event.checked)">
					Retail admin demo
				</mat-slide-toggle>
				<p class="text-muted small mt-1 mb-0">
					Cast this session as a retail campus admin at {{ retailAdminDemoAccountName }}. Sidebar, dashboard, and vouchers use canned Pacific Crest data. Reloads the app.
				</p>
				<p class="text-muted small mt-1 mb-0" *ngIf="voucherDemoMode.isEnabled()">
					Currently viewing as Retail Admin · {{ retailAdminDemoAccountName }}.
				</p>
			</div>
		</div>

		<div class="row mt-4" *ngIf="isSuperAdmin">
			<div class="col-12">
				<h4 class="mb-3">View As</h4>
				<p class="text-muted small mb-2">View the app from a different role's perspective. API requests will be filtered by the selected entity.</p>
				<p class="text-muted small mb-2" *ngIf="voucherDemoMode.isEnabled()">Turn off Retail admin demo before using View As.</p>
				<div class="d-flex flex-column gap-2">
					<mat-slide-toggle
						[checked]="viewAsEnabled"
						[disabled]="voucherDemoMode.isEnabled()"
						(change)="onViewAsEnabledChange($event.checked)">
						Enable View As
					</mat-slide-toggle>
					<div *ngIf="viewAsEnabled" class="mt-2">
						<div class="row">
							<div class="col-md-4 mb-2">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Role</mat-label>
									<mat-select [(value)]="viewAsRole" (selectionChange)="onViewAsRoleChange($event.value)">
										<mat-option *ngFor="let role of viewAsRoles" [value]="role.value">
											{{ role.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4 mb-2" *ngIf="viewAsRole === 'distiadmin'">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Distributor</mat-label>
									<mat-select [(value)]="viewAsDistiId" (selectionChange)="onViewAsDistiChange($event.value)" [disabled]="loadingDistributors">
										<mat-option [value]="null">Select Distributor</mat-option>
										<mat-option *ngFor="let disti of distributors" [value]="disti.value">
											{{ disti.label }}
										</mat-option>
									</mat-select>
									<mat-spinner *ngIf="loadingDistributors" diameter="20" class="inline-spinner"></mat-spinner>
								</mat-form-field>
							</div>
							<div class="col-md-4 mb-2" *ngIf="viewAsRole === 'clientadmin'">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Client</mat-label>
									<mat-select [(value)]="viewAsClientId" (selectionChange)="onViewAsClientChange($event.value)" [disabled]="loadingClients">
										<mat-option [value]="null">Select Client</mat-option>
										<mat-option *ngFor="let client of clients" [value]="client.value">
											{{ client.label }}
										</mat-option>
									</mat-select>
									<mat-spinner *ngIf="loadingClients" diameter="20" class="inline-spinner"></mat-spinner>
								</mat-form-field>
							</div>
							<div class="col-md-4 mb-2" *ngIf="viewAsRole === 'campusadmin'">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Campus</mat-label>
									<mat-select [(value)]="viewAsCampusId" [disabled]="loadingCampuses">
										<mat-option [value]="null">Select Campus</mat-option>
										<mat-option *ngFor="let campus of campuses" [value]="campus.value">
											{{ campus.label }}
										</mat-option>
									</mat-select>
									<mat-spinner *ngIf="loadingCampuses" diameter="20" class="inline-spinner"></mat-spinner>
								</mat-form-field>
							</div>
						</div>
						<div class="mt-2" *ngIf="viewAsScopeService.isEnabled()">
							<small class="text-muted">Currently viewing as: {{ getViewAsDisplayText() }}</small>
						</div>
						<div class="mt-2">
							<button mat-raised-button color="primary" (click)="saveViewAs()" [disabled]="savingViewAs">
								{{ savingViewAs ? 'Applying...' : 'Apply View As' }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<form [formGroup]="profileForm" class="mt-5" autocomplete="off">
			<div class="row">
				<div class="form-group" class="col-xl-4 col-md-5 col-sm-12" >
					<mat-form-field>
						<mat-label>First Name</mat-label>
						<input matInput type="text" placeholder="First Name" formControlName="firstName"/>
						<mat-error *ngIf="isControlHasError('firstName','required')">
							<strong>{{ 'Required field'}}</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('firstName','minlength')">
							<strong>{{ 'Minimum field length:'}} 3</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('firstName','maxlength')">
							<strong>{{ 'Maximum field length:'}} 100</strong>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="form-group" class="col-xl-4 col-md-5 col-sm-12">
					<mat-form-field>
						<mat-label>Last Name</mat-label>
						<input matInput type="text" placeholder="Last Name" formControlName="lastName"/>
						<mat-error *ngIf="isControlHasError('lastName','required')">
							<strong>{{ 'Required field'}}</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('lastName','minlength')">
							<strong>{{ 'Minimum field length:'}} 3</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('lastName','maxlength')">
							<strong>{{ 'Maximum field length:'}} 100</strong>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="form-group" class="col-xl-4 col-md-5 col-sm-12">
					<mat-form-field>
						<mat-label>{{ 'Email'}}</mat-label>
						<input matInput type="email" placeholder="{{ 'Email'}}" formControlName="email" autocomplete="off"/>
						<mat-error *ngIf="isControlHasError('email','required')">
							<strong>{{ 'Required field'}}</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('email','email')">
							<strong>{{ 'Field is not valid'}}</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('email','minlength')">
							<strong>{{ 'Minimum field length:'}} 3</strong>
						</mat-error>
						<mat-error *ngIf="isControlHasError('email','maxlength')">
							<strong>{{ 'Maximum field length:'}} 320</strong>
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<!-- <div class="form-group">
				<mat-checkbox name="agree" formControlName="agree">
					I agree the <a href="javascript:;">terms & conditions</a>
				</mat-checkbox>
			</div> -->
			<br>
			<!-- <button mat-raised-button type="submit" color="primary">Update Info</button> -->
		</form>

	</div>
	<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
		<div class="kt-form__actions kt-form__actions--sm p-3">
			<button mat-raised-button (click)="updateAttributes()" type="submit" color="primary">Update Info</button>
			<!-- <button (click)="submit()" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary ml-auto text-right" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}">{{ 'SUBMIT'}}</button> -->
		</div>
</div>
</div>
